import { Card } from '@app/components/various/Card';

export const AccountListCardSkeleton = () => {
  return (
    <Card.Wrapper>
      <Card.Header isLoading />
      <Card.Title isLoading />
      <div className="flex whitespace-pre">
        <Card.Link to="" isLoading />
      </div>
      <Card.AttributeList isLoading skeletonRows={1} />
    </Card.Wrapper>
  );
};
